export const version = '1.0.0'
export const name = 'libp2p'
